module.exports = __webpack_public_path__ + "static/media/metervibe_device_transparent.03edf4bc.png";